import React from 'react';
import { Search, X } from 'lucide-react';
import { Input } from 'components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'components/ui/select';

const ExportToolbar = ({ 
  searchText, 
  onSearch, 
  statusFilter, 
  onStatusChange,
  totalCount = 0,
  readyCount = 0,
  processingCount = 0 
}) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 w-full mb-4">
      {/* Left: Summary counter matching FavoritesToolbar layout */}
      <div className="text-sm text-gray-600">
        <span className="font-semibold text-gray-900">{totalCount}</span> {totalCount === 1 ? 'export' : 'exports'}
        {readyCount > 0 && (
          <span className="text-gray-400 ml-1.5 font-normal">({readyCount} ready)</span>
        )}
        {processingCount > 0 && (
          <span className="text-blue-600 ml-1.5 font-normal">({processingCount} processing)</span>
        )}
      </div>

      {/* Right: Search input & Status dropdown aligned and styled like FavoritesToolbar */}
      <div className="flex items-center gap-2.5 flex-wrap sm:flex-nowrap">
        <div className="relative w-full sm:w-64">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={15} />
          <Input 
            placeholder="Search exports..." 
            value={searchText}
            onChange={(e) => onSearch(e.target.value)}
            className="pl-9 pr-8 h-9 bg-white text-sm border-gray-200 rounded-lg focus-visible:ring-explore shadow-none"
          />
          {searchText && (
            <button
              type="button"
              onClick={() => onSearch('')}
              className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 p-0.5 rounded"
              title="Clear search"
            >
              <X size={13} />
            </button>
          )}
        </div>

        <Select value={statusFilter} onValueChange={onStatusChange}>
          <SelectTrigger className="w-[140px] h-9 bg-white border-gray-200 rounded-lg text-sm shadow-none focus:ring-explore">
            <SelectValue placeholder="Status" />
          </SelectTrigger>
          <SelectContent className="bg-white border-gray-200 shadow-md">
            <SelectItem value="all">All Statuses</SelectItem>
            <SelectItem value="ready">Ready</SelectItem>
            <SelectItem value="processing">Processing</SelectItem>
            <SelectItem value="queued">Queued</SelectItem>
            <SelectItem value="failed">Failed</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default ExportToolbar;
